(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panienski_przyklad"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.wpZoom) return;
    window.wpZoom = true;
    document.addEventListener('click', function (e) {
      var lb = document.getElementById('wp-lb');
      var link = e.target.closest('[data-wp-zoom]');
      if (link) {
        e.preventDefault();
        if (!lb) {
          lb = document.createElement('div');
          lb.id = 'wp-lb';
          lb.className = 'wp-lb';
          lb.innerHTML = '<img alt="">';
          document.body.appendChild(lb);
        }
        var img = lb.querySelector('img');
        var thumb = link.querySelector('img');
        img.src = link.getAttribute('href');
        img.alt = thumb ? thumb.alt : '';
        lb.classList.add('is-on');
        return;
      }
      if (lb && e.target.closest('#wp-lb')) lb.classList.remove('is-on');
    });
    document.addEventListener('keydown', function (e) {
      var lb = document.getElementById('wp-lb');
      if (e.key === 'Escape' && lb) lb.classList.remove('is-on');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
